import React, { useEffect, useRef } from 'react'
import './fpLoader.css'
import { useFpLoaderSelector } from '../../store/selectors/fpLoaderSelector'
import Loader from '../loader'

function AppLoader() {
    const show = useFpLoaderSelector()
    const loaderRef: any = useRef()

    useEffect(() => {
        if (show) {
            loaderRef?.current?.showModal()
        } else {
            loaderRef?.current?.close()
        }
    }, [show])

    return (
        <dialog ref={loaderRef}>
            <div className="app-loader-container">{show && <Loader />}</div>
        </dialog>
    )
}
export default AppLoader
